import script from "./SkyWizard.vue?vue&type=script&lang=js"
export * from "./SkyWizard.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__